export default [
  {
    id: 0,
    name: 'Admin Fee'
  },
  {
    id: 1,
    name: '3rd Party Fee'
  },
  {
    id: 2,
    name: 'BB Service'
  }
]



// WEBPACK FOOTER //
// ./src/constants/servicesCategories.js